import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification } from "antd";
import { faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import TobNavBar from "../../../DashBaord/Top_navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import {formatProjectDate} from "../../../../controllers/common";
import { InfoCircleOutlined, CheckCircleOutlined, } from "@ant-design/icons";
import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import {
  list,
  deleteRequest,
  updateInvoice,
  requestChangeStatus
} from "../../../../controllers/V1/invoice/invoiceControllers";
import {list as getLoadBalanceData} from "../../../../controllers/V1/walletStatement/walletStatementController";
import { list as dueList, updateDueAmount } from '../../../../controllers/V1/users/usersController';
import { getRelativeTime } from "../../../../controllers/common";
import Big from 'big.js';

const bp = (n) => new Big(parseFloat(n) || 0);
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


export default function BasicTabs() {
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const targetRef = useRef(null);
  const {batch_id}= useParams();
  const [ALLLISTDATA, setListData] = useState([]);

  const [pendingInvoice, setPendingInvoice] = useState([]);
  const [pendingInvoiceCount, setPendingInvoiceCount] = useState(0);
 
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          batch_no : batch_id
        },
        select: {},
        sort: { _id: -1 },
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          let updatedRetailerList = listData?.result.filter((retailer) => retailer?.status === 'Pending');
          // let updatedRetailerList = listData?.result.filter((retailer) => retailer?.status === 'Fail');
          // let updatedRetailerList = listData?.result.filter((retailer) => retailer?.users_id === 1005);
          setPendingInvoice(updatedRetailerList);
          setPendingInvoiceCount(updatedRetailerList?.length); 
        } else {
          setListData([]);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End
 

  /*********************************************************
   *  This function is use to handle remove invoice
   *********************************************************/
  const handleRemove = async (id='') => {
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Invoice id is required.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }else{
        const res = await deleteRequest(id);
        if (res.status === true) {
          notification.open({
            message: "Success",
            description: `Data deleted successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };
  
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "B-Winn || Invoice Generate";
  }, []);
  
  const getStatementDueAmount = (subTotalDue = 0, otherCharges = 0) =>
    parseFloat(bp(subTotalDue).plus(bp(otherCharges)).toFixed(2));

  const applyUserDueAmount = async (invoiceRow, dueAmount) => {
    if (!invoiceRow || isNaN(parseFloat(dueAmount))) {
      return { status: false, message: 'Invalid due amount' };
    }
    let res = await updateDueAmount({
      pos_number: invoiceRow?.pos_number || '',
      mobile_number: '',
      due_amount: dueAmount,
    });
    if (res.status !== true) {
      res = await updateDueAmount({
        pos_number: '',
        mobile_number: invoiceRow?.users_mobile || '',
        due_amount: dueAmount,
      });
    }
    return res;
  };

  const fetchUserDue = async (user_id) => {
    try {
      const option = {
        type : 'single',
        condition : { _id : user_id },
        select : {due_amount : true}
      }
      const res = await dueList(option);
      if(res.status === true){
        console.log("res.result?.due_amount : ", res.result?.due_amount);
        return res.result?.due_amount || 0;
      } else{
        return 0;
      }
    } catch (error) {
      return 0;
    }
  }

  useEffect(()=>{
    if(pendingInvoiceCount > 0){
      generateInvoice(pendingInvoice[pendingInvoiceCount - 1]);
    } else {
      requestChangeStatus(batch_id);
    }
  },[pendingInvoiceCount]);


/*********************************************************
 *  This function is use to handle form submit
 *********************************************************/
const generateInvoice = async (data) => {
  try {
    if(!data.users_id){
      alert('Please select user');
    } else{
      setListData((prev) =>
        prev.map((item) =>
          item._id === data._id ? { ...item, status: 'Preparing' } : item
        )
      );

      const startDate = `${data?.start_date} ${data?.start_time}`;
      const endDate = `${data?.end_date} ${data?.end_time}`;

      const options = {
        condition : {
          $or : [
            {debit_user : data?.users_oid},
            {credit_user : data?.users_oid}
          ],
          createdAt : { $gte : `${startDate}`, $lte : `${endDate}` }
        }
      }
      const res = await getLoadBalanceData(options);
      if(res?.status === true){
        const old_balance = await fetchUserDue(data?.users_oid);
        // console.log("old_balance : ", old_balance); 
        let lottoTotalSales, lottoTotalCommission , lottoPaidAmount, lottoIncentives;

        let voucherTotalSales, voucherTotalCommission, voucherPaidAmount, voucherIncentives;
        
        let e_commTotalSales, e_commTotalCommission, e_commPaidAmount, e_commIncentives;

        let totalSales, totalCommission, paidAmount, incentives;

        let totalDue;

        let other_charges;

        let subTotalDue; 

        let status = 'Completed';
        let remarks = '';
        if(res?.result?.length > 0 || old_balance > 0){

          // Accumulate transaction points using Big.js
          const result = res?.result.reduce(
            (acc, item) => {
              const pts = bp(item.points);
              // Lotto ~ Daily Draw
              if (item.narration === 'Campaign Purchase') {
                acc.lottoSales = acc.lottoSales.plus(pts);
              } else if (item.narration === 'Campaign Commission') {
                acc.lottoCommission = acc.lottoCommission.plus(pts);
              } else if (item.narration === 'Campaign Purchase Cancel') {
                acc.lottoCancel = acc.lottoCancel.plus(pts);
              } else if (item.narration === 'Campaign Commission Reverse') {
                acc.lottoCommissionReverse = acc.lottoCommissionReverse.plus(pts);
              } else if (item.narration === 'Lotto Winner Redeem') {
                acc.lottoAmountPaid = acc.lottoAmountPaid.plus(pts);
              } else if (item.narration === 'Reverse Lotto Winner Redeem') {
                acc.lottoAmountPaid = acc.lottoAmountPaid.minus(pts);
              // Vouchers
              } else if (item.narration === 'Voucher Purchase') {
                acc.voucherSales = acc.voucherSales.plus(pts);
              } else if (item.narration === 'Voucher Commission') {
                acc.voucherCommission = acc.voucherCommission.plus(pts);
              } else if (item.narration === 'Voucher Order Cancel') {
                acc.voucherCancel = acc.voucherCancel.plus(pts);
              } else if (item.narration === 'Voucher Commission Reverse') {
                acc.voucherCommissionReverse = acc.voucherCommissionReverse.plus(pts);
              // Products / E-Comm
              } else if (item.narration === 'Product Order') {
                acc.e_commSales = acc.e_commSales.plus(pts);
              } else if (item.narration === 'Product Cancel') {
                acc.e_commCancel = acc.e_commCancel.plus(pts);
              }
              return acc;
            },
            {
              lottoSales:             new Big(0),
              lottoCommission:        new Big(0),
              lottoCancel:            new Big(0),
              lottoCommissionReverse: new Big(0),
              lottoAmountPaid:        new Big(0),
              voucherSales:           new Big(0),
              voucherCommission:      new Big(0),
              voucherCancel:          new Big(0),
              voucherCommissionReverse: new Big(0),
              e_commSales:            new Big(0),
              e_commCancel:           new Big(0),
            }
          );

          // Derived totals — all Big.js
          const totalLottoSales       = result.lottoSales.minus(result.lottoCancel);
          const totalLottoCommission  = result.lottoCommission.minus(result.lottoCommissionReverse);
          const totalVoucherSales     = result.voucherSales.minus(result.voucherCancel);
          const totalVoucherCommission = result.voucherCommission.minus(result.voucherCommissionReverse);
          const totalE_commSales      = result.e_commSales.minus(result.e_commCancel);

          const totalSalesAmount      = totalLottoSales.plus(totalVoucherSales).plus(totalE_commSales);
          const totalCommissionAmount = totalLottoCommission.plus(totalVoucherCommission);
          const totalPaidAmount       = result.lottoAmountPaid;

          const totaldue              = totalSalesAmount.minus(totalCommissionAmount).minus(totalPaidAmount);
          const subTotalDueAmount     = totaldue.plus(bp(old_balance));

          // Assign to invoice variables (stored as 2dp strings for API / display)
            lottoTotalSales      = parseFloat(totalLottoSales.toFixed(2));
            lottoTotalCommission = parseFloat(totalLottoCommission.toFixed(2));
            lottoPaidAmount      = parseFloat(totalPaidAmount.toFixed(2));
            lottoIncentives      = 0;

            voucherTotalSales      = parseFloat(totalVoucherSales.toFixed(2));
            voucherTotalCommission = parseFloat(totalVoucherCommission.toFixed(2));
            voucherPaidAmount      = 0;
            voucherIncentives      = 0;

            e_commTotalSales      = parseFloat(totalE_commSales.toFixed(2));
            e_commTotalCommission = 0;
            e_commPaidAmount      = 0;
            e_commIncentives      = 0;

            totalSales      = parseFloat(totalSalesAmount.toFixed(2));
            totalCommission = parseFloat(totalCommissionAmount.toFixed(2));
            paidAmount      = parseFloat(totalPaidAmount.toFixed(2));
            incentives      = 0;

            totalDue      = parseFloat(totaldue.toFixed(2));
            other_charges = 0;
            subTotalDue   = parseFloat(subTotalDueAmount.toFixed(2));
          

        } else {
          status = 'Fail';
          remarks = 'No sales found'
        }

        const params = {
          id : data._id,

          lottoTotalSales : lottoTotalSales,
          lottoTotalCommission : lottoTotalCommission,
          lottoPaidAmount : lottoPaidAmount,
          lottoIncentives : lottoIncentives,

          voucherTotalSales : voucherTotalSales,
          voucherTotalCommission : voucherTotalCommission,
          voucherPaidAmount : voucherPaidAmount,
          voucherIncentives : voucherIncentives,

          e_commTotalSales : e_commTotalSales,
          e_commTotalCommission : e_commTotalCommission,
          e_commPaidAmount : e_commPaidAmount,
          e_commIncentives : e_commIncentives,

          total_sales : totalSales,
          total_commission : totalCommission,
          total_paid : paidAmount,
          total_incentives : incentives,

          total_due : totalDue,

          old_pending_balance : old_balance,

          other_charges : other_charges,

          sub_total_due : subTotalDue,
          
          status : status,
          remarks : remarks
        }
        const invoiceRes = await updateInvoice(params);

        if (invoiceRes?.status === true && data?.add_in_due === 'Y' && status === 'Completed') {
          const dueUpdateRes = await applyUserDueAmount(
            data,
            getStatementDueAmount(subTotalDue, other_charges)
          );
          if (dueUpdateRes.status !== true) {
            remarks = remarks
              ? `${remarks}; Due update failed: ${dueUpdateRes?.message || 'System error'}`
              : `Due update failed: ${dueUpdateRes?.message || 'System error'}`;
          }
        }
        
        setListData((prev) =>
          prev.map((item) =>
            item._id === data._id ? { 
              ...item, 

              lottoTotalSales : lottoTotalSales,
              lottoTotalCommission : lottoTotalCommission,
              lottoPaidAmount : lottoPaidAmount,
              lottoIncentives : lottoIncentives,

              voucherTotalSales : voucherTotalSales,
              voucherTotalCommission : voucherTotalCommission,
              voucherPaidAmount : voucherPaidAmount,
              voucherIncentives : voucherIncentives,

              e_commTotalSales : e_commTotalSales,
              e_commTotalCommission : e_commTotalCommission,
              e_commPaidAmount : e_commPaidAmount,
              e_commIncentives : e_commIncentives,

              totalSales : totalSales,
              totalCommission : totalCommission,
              paidAmount : paidAmount,
              incentives : incentives,

              total_sales : totalSales,
              total_commission : totalCommission,
              total_paid : paidAmount,
              total_incentives : incentives,

              total_due : totalDue,

              old_pending_balance : old_balance,

              other_charges : other_charges,

              sub_total_due : subTotalDue,

              status: params.status, 
              remarks : params.remarks 
            } : item
          )
        );
        setPendingInvoiceCount(pendingInvoiceCount - 1);
      }
    }
  } catch (error) {
    console.log("error", error);
    // setIsLoading(false);
  }
};


const handlePDFDownload = async (invoiceData) => {
  try { 
    const {
      store,users_name,pos_number,users_mobile,bind_person_name,bind_person_mobile,invoice_date,invoice_no,payment_mode,start_date,end_date,start_time,end_time,area,
      lottoTotalSales, lottoTotalCommission, lottoPaidAmount, lottoIncentives,
      e_commTotalSales, e_commTotalCommission, e_commPaidAmount, e_commIncentives,
      voucherTotalSales, voucherTotalCommission, voucherPaidAmount, voucherIncentives,

      total_sales,total_commission,total_paid,total_due,other_charges,old_pending_balance,sub_total_due,total_incentives,

      } = invoiceData;
    const isValidate = true
    if(!isValidate){
      alert('Incomplete invoice data');
    }else{
      
      let previewURL = `/invoice/preview?`
      previewURL    +=  `autoDownload=Y`
      previewURL    +=  `&store_name=${store}`
      previewURL    +=  `&user_name=${users_name}`
      previewURL    +=  `&pos_number=${pos_number}`
      previewURL    +=  `&mobile=${users_mobile}`
      previewURL    +=  `&totalSales=${total_sales}`
      previewURL    +=  `&totalCommission=${total_commission || 0}`
      previewURL    +=  `&paidAmount=${total_paid || 0}`
      previewURL    +=  `&totalDue=${total_due || 0}`
      previewURL    +=  `&other_charges=${other_charges || 0}`
      previewURL    +=  `&old_balance=${old_pending_balance || 0}`
      previewURL    +=  `&subTotalDue=${sub_total_due || 0}`
      previewURL    +=  `&incentives=${total_incentives || 0}`
      previewURL    +=  `&invoice_date=${invoice_date}`
      previewURL    +=  `&invoice_no=${invoice_no}`
      previewURL    +=  `&payment_mode=${payment_mode}`
      previewURL    +=  `&start_date=${start_date}`
      previewURL    +=  `&start_time=${start_time}`
      previewURL    +=  `&end_date=${end_date}`
      previewURL    +=  `&end_time=${end_time}`
      previewURL    +=  `&bind_person_name=${bind_person_name}`
      previewURL    +=  `&bind_person_mobile=${bind_person_mobile}`
      previewURL    +=  `&area=${area}`

      previewURL    +=  `&lottoTotalSales=${lottoTotalSales || 0}`
      previewURL    +=  `&lottoTotalCommission=${lottoTotalCommission || 0}`
      previewURL    +=  `&lottoPaidAmount=${lottoPaidAmount || 0}`
      previewURL    +=  `&lottoIncentives=${lottoIncentives || 0}`

      previewURL    +=  `&e_commTotalSales=${e_commTotalSales || 0}`
      previewURL    +=  `&e_commTotalCommission=${e_commTotalCommission || 0}`
      previewURL    +=  `&e_commPaidAmount=${e_commPaidAmount || 0}`
      previewURL    +=  `&e_commIncentives=${e_commIncentives || 0}`

      previewURL    +=  `&voucherTotalSales=${voucherTotalSales || 0}`
      previewURL    +=  `&voucherTotalCommission=${voucherTotalCommission || 0}`
      previewURL    +=  `&voucherPaidAmount=${voucherPaidAmount || 0}`
      previewURL    +=  `&voucherIncentives=${voucherIncentives || 0}`

      
      window.open(previewURL, '_blank');
    }
  } catch (error) { 
    console.log('error', error)
  }
}

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Invoice Request List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
           {(ALLLISTDATA?.length > 0 && pendingInvoiceCount > 0) && (
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <h4>Successfully processed {pendingInvoiceCount} out of the {ALLLISTDATA.length} invoices.</h4>  
                  <blink >Preparing {pendingInvoice[pendingInvoiceCount - 1]?.store} invoice... </blink>
                </div>                  
              </div>
            </Box>                      
           )} 
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl No.</th>
                              <th>Customer's Details</th>
                              <th>Period</th>
                              <th>Amount</th>
                              <th>Due Date</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className="admin_user_list_date"> 
                                      <span>Store : {items?.store}</span><br/>
                                      <span>Name : {items?.users_name}</span><br/> 
                                      <span>Mobile : {items?.users_mobile}</span>
                                    </td>
                                    <td className="admin_user_list_date">
                                      From : 
                                      {`
                                        ${moment(items?.start_date).subtract(4, 'hours').format("DD-MM-YYYY")} 
                                        ${moment(`2025-03-03 ${items?.start_time}`).format("hh:mm A")}
                                      `} 
                                      <br/>
                                      To : 
                                      {`
                                        ${moment(`${items?.end_date}`).subtract(4, 'hours').format("DD-MM-YYYY")} 
                                        ${moment(`2025-03-03 ${items?.end_time}`).format("hh:mm A")}
                                      `} 
                                    </td>
                                    <td className="admin_user_list_date">{items.sub_total_due != null ? parseFloat(items.sub_total_due).toFixed(2) : '-'}</td>
                                    {items?.sub_total_due?(
                                      <td className="admin_user_list_date">
                                        <h6 dangerouslySetInnerHTML={{ __html: getRelativeTime(items?.due_date) }}></h6>
                                        {moment(`${items?.due_date}`).format("DD-MM-YYYY")}
                                      </td>

                                    ):(
                                      <td className="admin_user_list_date">-</td>
                                    )}
                                      
                                    <td className="admin_user_list_date">{items?.status}</td>
                                    <td>
                                      <Dropdown
                                        overlay={
                                          <>
                                            <Menu>
                                              {items?.status === 'Fail'?(
                                                <Menu.Item>{items?.remarks}</Menu.Item>  
                                              ):(<>
                                                <Menu.Item
                                                  key={`02`}
                                                  onClick={() => {
                                                    handlePDFDownload(items);
                                                  }}
                                                >
                                                <FontAwesomeIcon icon={faDownload} /> <span className="show_span">PDF</span>
                                                </Menu.Item>

                                                <Menu.Item
                                                  key={`01`}
                                                  onClick={() => {
                                                    handleRemove(items._id);
                                                  }}
                                                >
                                                   <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Remove</span>
                                                </Menu.Item>
                                              </>)}
                                            </Menu>
                                          </>
                                        }
                                        placement="bottomLeft"
                                        arrow
                                      >
                                       <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={7} /> : <tr> 
                                <td colspan="7" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
    </>
  );
}
